module.exports = __webpack_public_path__ + "static/img/04994497.6f42aad5.png";